import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { schoolInfo, images } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const AboutSection = () => {
  const { t } = useLanguage();

  const highlights = [
    { en: 'Certified professional instruction', id: 'Instruksi profesional bersertifikat' },
    { en: 'Small class sizes for individual attention', id: 'Ukuran kelas kecil untuk perhatian individu' },
    { en: 'Age-appropriate curriculum', id: 'Kurikulum sesuai usia' },
    { en: 'Nurturing and supportive environment', id: 'Lingkungan yang memelihara dan mendukung' },
    { en: 'Regular performances and recitals', id: 'Pertunjukan dan resital reguler' },
  ];

  return (
    <section id="about" className="py-24 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-[#f0efed]">
              <img
                src={images.about}
                alt="Ballet dancer"
                className="w-full h-auto object-contain"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#8B1C1C]/20 to-transparent" />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-xl p-6 max-w-[200px]">
              <p className="text-4xl font-bold text-[#8B1C1C]">{schoolInfo.studentsCount}</p>
              <p className="text-[#736c64] text-sm mt-1">
                {t('Happy young dancers in Surabaya', 'Penari muda bahagia di Surabaya')}
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block text-[#8B1C1C] font-semibold text-sm uppercase tracking-wider mb-4">
              {t('About Us', 'Tentang Kami')}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-6 leading-tight">
              {t(
                'Nurturing Young Talents Through Classical Ballet',
                'Membina Bakat Muda Melalui Balet Klasik'
              )}
            </h2>
            <p className="text-[#736c64] text-lg leading-relaxed mb-8">
              {t(schoolInfo.descriptionEn, schoolInfo.descriptionId)}
            </p>

            {/* Highlights */}
            <div className="space-y-4">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#8B1C1C] flex-shrink-0" />
                  <span className="text-[#1e1919]">{t(item.en, item.id)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
